import { Component, OnInit, ViewChild, Input, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatPaginator, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { UIService } from '../../services/ui.service';
import { APIService } from '../../services/api.service';
import { StorageService } from '../../services/storage.service';

import * as moment from 'moment';

@Component({
    selector: 'cs-premios',
    templateUrl: './premios.component.html',
    styleUrls: ['./premios.component.scss']
})
export class PremiosComponent implements OnInit {

    @Input() modal: string = undefined;
    @Input() publico: string = undefined;

    @ViewChild(MatPaginator) paginator: MatPaginator;

    public model: any = {
        Clientes: false,
        Colaboradores: true
    };

    public total: number;
    public premios: any[] = [];

    public premiosSelecionados: any[] = [];

    public sugestoes: any = {
        Redes: [],
        Grupos: [],
        Segmentos: [],
        Complexos: []
    };

    public quantidade: number = 10;

    constructor(public dialog: MatDialog, private ui: UIService, private api: APIService, private router: Router, private storage: StorageService) {
    }

    ngOnInit() {

        if (this.publico === 'Clientes') {

            this.model.Clientes = true;
            this.model.Colaboradores = false;
        }
        else if (this.publico === 'Colaboradores') {

            this.model.Clientes = false;
            this.model.Colaboradores = true;
        }

        this.api.obterSugestoes().subscribe(

            (response: any) => {

                if (!response.error) {

                    this.sugestoes = response.data;
                }
            }
        );

        setTimeout(() => {

            this.paginator.pageSize = 10;

            this.loadSession();
        });
    }

    limparFiltro() {

        this.model = {
            Clientes: false,
            Colaboradores: true
        };
    }

    filtrar(page?: number) {

        this.ui.block('Pesquisando premios...');

        const skip: number = (page || this.paginator.pageIndex) * this.paginator.pageSize;

        const parameter: any = JSON.parse(JSON.stringify(this.model));

        parameter.Validade = (moment(parameter.Validade) as any).toNET();
        parameter.Take = this.paginator.pageSize;
        parameter.Skip = skip;

        this.api.obterVouchers(parameter).subscribe(

            (response: any) => {

                this.ui.unblock();

                if (response.error) {

                    this.ui.error(response.error);
                }
                else {

                    for (const premio of response.data.Vouchers) {

                        const qrCode: string[] = premio.QRCode.split('|');

                        premio.QRCode = {
                            Top: qrCode[0],
                            Left: qrCode[1],
                            HalfTop: (Number(qrCode[0].replace('px', '')) / 2).toFixed(0) + 'px',
                            HalfLeft: (Number(qrCode[1].replace('px', '')) / 2).toFixed(0) + 'px',
                            Front: qrCode[2],
                            Back: qrCode[3]
                        };

                        premio.Estoque = premio.Estoque.filter(a => a.Status === 'Estoque' || a.Status === 'Entregue' || a.Status === 'Utilizado');
                    }

                    this.total = response.data.Total;
                    this.premios = response.data.Vouchers;

                    if (page) {

                        this.paginator.pageIndex = page;
                    }
                }

                this.storage.set('session', undefined);
            }
        );
    }

    pageChanged(page: any) {

        this.filtrar();
    }

    newRecord(modelo?: number) {

        this.saveSession();

        if (!modelo) {

            this.router.navigate(['/premios', 0]);
        }
        else {

            this.router.navigate(['/premios', 0, modelo]);
        }
    }

    editRecord(element: any) {

        this.saveSession();
        this.router.navigate(['/premios', element.ID]);
    }

    saveSession() {

        this.storage.set('session', {
            model: this.model,
            page: {
                size: this.paginator.pageSize,
                current: this.paginator.pageIndex
            }
        });
    }

    loadSession() {

        const session = this.storage.get('session');

        if (session && (session.model.Clientes || session.model.Colaboradores)) {

            this.model = session.model;
            this.model.Clientes = false;
            this.model.Colaboradores = true;
            this.paginator.pageSize = session.page.size;

            this.filtrar(session.page.current);
        }
        else {

            this.filtrar();
        }
    }

    selecionaPremio(premio: any) {

        if (this.modal === 'single') {

            this.premiosSelecionados = [premio];
        }
        else {

            this.dialog.open(DialogVisualizarPremiosComponent, {
                width: '414px',
                height: '736px',
                data: { premio: JSON.parse(JSON.stringify(premio)) }
            });
        }
    }

    premioSelecionado(premio: any) {

        return this.premiosSelecionados.some((_premio) => _premio.ID === premio.ID);
    }

    icon(status: string) {

        if (status === 'Estoque') return 'work';
        else if (status === 'Disponivel') return 'style';
        else if (status === 'Entregue') return 'how_to_reg';
        else if (status === 'Utilizado') return 'verified_user';
        else if (status === 'Vencido') return 'not_interested';
    }

    descricao(status: string) {

        if (status === 'Estoque') return 'em estoque';
        else if (status === 'Disponivel') return 'disponíveis nas lojas';
        else if (status === 'Entregue') return 'adquiridos por colaboradores';
        else if (status === 'Utilizado') return 'resgatados (utilizados)';
        else if (status === 'Vencido') return 'vencidos';
    }

    pedirQuantidadePremios(premio: any) {

        this.premiosSelecionados = [premio];

        const dialogRef = this.dialog.open(DialogMaisPremiosComponent, {
            width: '250px',
            data: { premios: 100 }
        });

        dialogRef.afterClosed().subscribe(result => {

            if (result) {

                this.gerarMaisPremios(result);
            }
        });
    }

    gerarMaisPremios(premios: number) {

        this.ui.block('Gerando premios...');

        const parameter: any = {
            Vouchers: this.premiosSelecionados.map((premio) => premio.ID),
            Quantidade: premios
        };

        this.api.gerarMaisVouchers(parameter).subscribe(

            (response: any) => {

                this.ui.unblock();

                if (response.error) {

                    this.ui.error(response.error);
                }
                else {

                    for (const premio of this.premiosSelecionados) {

                        for (const estoque of premio.Estoque) {

                            if (estoque.Status === 'Estoque') {

                                estoque.Quantidade = Number(estoque.Quantidade) + Number(premios);
                            }
                        }
                    }

                    this.premiosSelecionados = [];
                    this.quantidade = 10;

                    this.ui.success('Premios criados com sucesso!');
                }
            }
        );
    }
}

@Component({
    selector: 'cs-mais-premios',
    template: `
        <div style="padding: 24px;">

            <h1 mat-dialog-title>Adicionar Prêmios</h1>

            <div mat-dialog-content>

                <p>Informe a quantidade de prêmios que deseja adicionar ao estoque:</p>

                <mat-form-field>
                    <input type="number" matInput [(ngModel)]="data.premios" cdkFocusInitial style="text-align: right;">
                </mat-form-field>

            </div>

            <div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
                <button mat-button (click)="cancel()">Cancelar</button>
                <button mat-button mat-raised-button color="primary" [mat-dialog-close]="data.premios">Gerar</button>
            </div>

        </div>
    `,
})
export class DialogMaisPremiosComponent {

    constructor(public dialogRef: MatDialogRef<DialogMaisPremiosComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    cancel(): void {

        this.dialogRef.close();
    }
}

@Component({
    selector: 'cs-visualizar-premios',
    template: `
        <div style="position: relative; cursor: alias;" (click)="flip()">

            <img [src]="data.premio.Lado !== 2 ? data.premio.ImagemFrente : data.premio.ImagemVerso">

            <div *ngIf="data.premio.Lado !== 2" style="position: absolute;" [style.top]="data.premio.QRCode.Top" [style.left]="data.premio.QRCode.Left">
                <qrcode [qrdata]="'000000'" [size]="100" [level]="'M'" [colordark]="data.premio.QRCode.Front" [colorlight]="data.premio.QRCode.Back"></qrcode>
                <h3 style="font-size: 24px; font-weight: bold; line-height: 1; margin: 5px 0 0; text-align: center;" [style.color]="data.premio.QRCode.Front">#000000</h3>
            </div>

        </div>
`,
})
export class DialogVisualizarPremiosComponent {

    constructor(public dialogRef: MatDialogRef<DialogVisualizarPremiosComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    flip(): void {

        if (this.data.premio.Lado === 2) {

            this.data.premio.Lado = 1;
        }
        else {

            this.data.premio.Lado = 2;
        }
    }
}
